import { IDonor } from './donor';
import { IRecipient } from './recipient';
import { ISingleEpletMmRisk } from './single-eplet-mm-risk';
import { IGpsAutomation } from './gps-automation';
import { IMatchHistory } from './match-history';
import { IXmTracking } from './xm-tracking';
import { IDutyOfficer } from './duty-officer';
import { ISwapManager } from './swap-manager';
import { IDonorPreselect } from './matching';
import { ICompatibilityResult } from './compatibility-result';
import { EmailStatusType } from '@nkr/enums/email-status-type';
import { OfferNowType } from '@nkr/enums/swap-offer-now-type';
import { PreSelectReversalResponsible } from '@nkr/enums/preselect-reversal-responsible';

export interface IPosition {
    chainId: number,
    clusterId: number,
    clusterNumber: number,
    positionNumber: number,
    donor: IDonor,
    recipient: IRecipient,
    vbd: string,
    pmp: string,
    cPRA4: string,
    singleEpletMmRisk: ISingleEpletMmRisk,
    pts: string,
    wt: string,
    ewt: string,
    rexm: string,
    pairStatusId: number,
    gpsAutomation: IGpsAutomation,
    logistics: string,
    unosSurgery: string[],
    clusterStatusId: number,
    chainStatusId: number,
    kidneyPickup: string,
    kidneyArrival: string,
    kidneyPickupActual: string,
    kidneyArrivalActual: string,
    transplantDate: string,
    donationStartDate: string,
    donationEndDate: string,
    offerImmediately: boolean,
    flagToMatchDate: string
    note: string,
    matchHistory: IMatchHistory,
    xmTracking: IXmTracking[],
    compatiblePairStartDate: string,
    compatiblePairEndDate: string,
    isPickupDateOutsideRange: boolean,
    isDeliveryDateOutsideRange: boolean,
    customLogisticsStatus: number,
    excludedPlaceholderCenters: number[],
    dutyOfficer: IDutyOfficer,
    swapManager: ISwapManager,
    donorSurgeryConflicts: string[],
    recipientSurgeryConflicts: string[],
    recipientDeclinedDates: string[],
    shouldBeRedeye: boolean,
    isDataComplete: boolean,
    isPreAccepted: boolean,
    recipientDonationBeforeVhDonation: boolean,
    hasClc: boolean,
    donorPreselect: IDonorPreselect,
    compatibilityResult: ICompatibilityResult,
    pairMatchPower: string,
    bmtMm: number,
    emailStatus: EmailStatusType,
    hasPreselectReversal: boolean,
    hasSurgicalDecline: boolean,
    reversalResponsible: PreSelectReversalResponsible,
    preselectDeclineReasons: { reason: string, otherText: string }[],
    matchOfferDeclineReasons: { reason: string, otherText: string, nextAvailText: string }[],
    offerNowType: OfferNowType
}
